import messages_en from './en.json';
import messages_pt from './pt.json';

export const translationMessages = {
  en: messages_en,
  pt: messages_pt,
};

export const availableLanguages = ['pt', 'en'];

export const isValidLanguage = (language: string) => {
  return (
    availableLanguages.findIndex(
      (item) => item.toLowerCase() === language.toLowerCase()
    ) > -1
  );
};
